<app-loading [mosTexto]="true" *ngIf="cargando"></app-loading>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'PAGADURIA.LBL_PAGADURIA' | translate}}</h1>
  </div>
</div>
<form (ngSubmit)="buscar()" [formGroup]="formulario" novalidate>
<div class="grid pr-3" *ngIf="!cargando">
  <div class="grid form-group" style="align-items: center; display: flex">
    <div class="col-12 md:col-6 lg:col-6">
      <div class="btn-group" role="group">
        <div class="div-form">
          <button label="{{'BTN_AGREGAR' | translate }}"
                  type="button" pButton icon="fa fa-plus"
                  *ngIf="this.verAgregar" style="margin-right: 10px"
                  (click)="agregar()"></button>
          <button label="{{'BTN_FILTRAR' | translate }}" type="submit" pButton
                  icon="fa fa-filter"></button>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6 lg:col-6">
      <div class="div-form" style="display: flex">
        <div class="col-12 md:col-6 lg:col-6">
        <label>{{ 'PAGADURIA.LBL_ESTADOPAGADURIA' | translate }}</label>
          <p-multiSelect [options]="lisEstadosTiposFuncionalidades"
                         selectedItemsLabel="{0} {{
                          'LBL_ELEMENTOSSELECCIONADOS' | translate
                        }}"
                         maxSelectedLabels="2"
                         formControlName="estadoFuncionalidad"
                         defaultLabel="{{'LBL_SELECCIONE' | translate}}"
                         [showToggleAll]="true" (select)="this.cEstadoFuncionalidad.ACTIVO"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
        </div>
        <div class="col-12 md:col-6 lg:col-6" style="padding-top: 25px">
          <input type="text" pInputText size="40" (change)="buscar()"
                 formControlName="buscar"
                 placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="busqueda"/>
        </div>
      </div>
    </div>

  </div>
</div>
</form>

<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="cargandoTabla" #dt
      [value]="pagaduriasListado" [paginator]="true" [rows]="10" [totalRecords]="numRegistros"
      [lazy]="true"  (onLazyLoad)="buscar($event)"
      paginatorPosition="bottom"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{row.codigo}}</td>
          <td class="table-break" style="width: 20%">{{row.pagaduria}}</td>
          <td>{{row.nit ? row.nit : '---'}}</td>
          <td>{{row.diaCorte ? row.diaCorte : '---'}}</td>
          <td>{{row.diaPago ? row.diaPago : '---'}}</td>
          <td>{{row.metodo ? row.metodo : '---'}}</td>
          <td>{{row.desfaseAntes ? row.desfaseAntes : '---'}}</td>
          <td>{{row.desfaseDespues ? row.desfaseDespues : '---'}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.aprobacionPagaduria" binary="true" disabled="true"></p-checkbox>
          </td>
          <td>{{row.empresa }}</td>
          <td>{{row.estadoFuncionalidad}}</td>
          <td>
            <div class="btn-group" role="group" style="display: flex; justify-content: center;">
              <button type="button" class="p-button p-button-success btn" icon="fa fa-eye" data-toggle="tooltip"
                      title="{{'PAGADURIA.BTN_VISUALIZAR' | translate}}" pButton (click)="verPagaduria(row)"></button>

              <button *ngIf="this.verAgregar  || (verAprobacionCondicion && row.indicadorCondicionPendiente)" type="button" class="p-button p-button-success btn" icon="fa fa-pencil"
                      (click)="editar(row)" data-toggle="tooltip"
                      title="{{'PAGADURIA.BTN_EDITAR' | translate}}" pButton></button>

              <button type="button" class="p-button p-button-success btn" icon="fa fa-check" data-toggle="tooltip" *ngIf="mostrarActivarTarea"
                      title="{{'PAGADURIA.BTN_ACTIVAR' | translate}}" pButton (click)="lanzarTarea(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ "MSG_NOHAYREGISTROS" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-confirmDialog #cd3 key="cambio-estado">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd3.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd3.accept()"></button>
  </ng-template>
</p-confirmDialog>
